export default __webpack_public_path__ + "static/media/general_bleu_saumon.1007b122.svg";